module.exports = "<p>\n  loader-service works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/loader-service/loader-service.component.html
// module id = ../../../../../src/app/loader-service/loader-service.component.html
// module chunks = main